import { getNoContentApiClient } from 'adapter/out/client/apiClient';
import DeleteAutomationCriteria from 'use-case/automation/delete/deleteAutomationCriteria';

export default getNoContentApiClient(
    (criteria: DeleteAutomationCriteria) => `dashboards/automations/${criteria.id}`,
    () => ({
        method: 'DELETE',
    })
);
